import { createSvgComponent } from "../../icon/createSvgComponent";
import Moneybag from "@core/__generated__/icon/figma/moneybag.svg";
export default createSvgComponent(Moneybag);